module.exports = __webpack_public_path__ + "static/media/management-user.603d21a0.png";